import React, { useEffect, useState } from 'react'
import './App.scss'
import FURenderKit from './components/FURenderkit'
import { Mask, SpinLoading } from 'antd-mobile'
import FUIcon from './components/Common/FUIcon'
import VConsole from "vconsole"
import { RENDER_SDK, RESOURCE_MANAGER } from './config'
import { Spin } from 'antd'

const isDebug = window.location.search.indexOf('debug') !== -1;
if (isDebug) {
    new VConsole()
}

type ExistProperty<T extends Object> = {
    [K in keyof T]-?: T[K]
}
type ContextOriginType<T extends Object> = T extends React.Context<infer R> ? R : never
export type FilterContext<T extends Object> = ContextOriginType<T> extends Object
    ? ExistProperty<ContextOriginType<T>>
    : never

export const NAVIGATOR = [
    {
        // title: 'Avatar 形象',
        title: '形象',
        children: [
            {
                key: 'render',
                title: '形象渲染',
                icon: <FUIcon
                    size="48px"
                    name='slices/icon_home_avatar_female.png'
                />,
                description: '查看个性化数字人形象'
            },
            {
                key: 'dressup',
                title: '形象自定义',
                icon: <FUIcon
                    size="48px"
                    name='slices/icon_home_avatar_male.png'
                />,
                description: '低门槛打造设计个性化数字人形象'
            },
            {
                key: 'creator',
                title: 'AI形象生成',
                icon: <FUIcon
                    size="48px"
                    name='slices/icon_home_avatar_camera.png'
                />,
                description: '查看个性化数字人形象'
            }
        ]
    },
    {
        // title: 'Avatar 驱动',
        title: '驱动',
        children: [
            {
                key: 'tts',
                title: '文本/语音驱动',
                icon: <FUIcon
                    size="48px"
                    name='slices/icon_home_tts_drive.png'
                />,
                description: '查看个性化数字人形象'
            },
        ]
    },
    {
        // title: 'Avatar 云资源',
        title: '云资源',
        children: [
            {
                key: 'animation',
                title: '动作资源',
                icon: <FUIcon
                    size="48px"
                    name='slices/icon_home_action_library.png'
                />,
                description: '查看个性化数字人形象'
            },
            {
                key: 'material',
                title: '素材资源',
                icon: <FUIcon
                    size="48px"
                    name='slices/icon_home_cloth_material.png'
                />,
                description: '低门槛打造设计个性化数字人形象'
            },
        ]
    },
    {
        // title: 'Avatar 云渲染API',
        title: '云渲染API',
        children: [
            {
                key: 'cloud_render/video',
                title: '视频模板',
                icon: <FUIcon
                    size="48px"
                    name='slices/icon_home_video_template.png'
                />,
                description: '查看个性化数字人形象'
            },
            {
                key: 'cloud_render/image',
                title: '图片模板',
                icon: <FUIcon
                    size="48px"
                    name='slices/icon_home_picture_template.png'
                />,
                description: '低门槛打造设计个性化数字人形象'
            },
            {
                key: 'cloud_render/gif',
                title: '表情包模板',
                icon: <FUIcon
                    size="48px"
                    name='slices/icon_home_emoji_template.png'
                />,
                description: '查看个性化数字人形象'
            }
        ]
    },
] as const

type NaviType = typeof NAVIGATOR

export type CompTypes = NaviType[number]['children'][number]['key'] | undefined
export const PUBLIC_PATH = ''

function App() {

    return (
        <div className="App">
            {
                <FURenderKit />
            }
        </div>
    )
}

export default App
